

export const lang = {
   Container:"BOX",
     Cbm:"CBM",
      Weight:"Weight",
  Balance:"Balance",
  ThisYear:"ThisYear",
  LastYear:"LastYear",
  Privacy_Policy:"Privacy policy",
  Agree:"Agree",
  user_name_not_exists:"User name not exists",
  password_wrong:"Password wrong",
  CompanyInfo:"Company Info",
    Please_set_materialtype_in_product_page:"Please set materialtype in product page",
    deleteAccount:"Delete Account",
    deleteAccountWillDeleteAllData:"Delete Account Will Delete All Data and logout",
    backupDatabase:"Backup Database",
    restoreDatabase:"Restore Database",
    materialtype:"Material Type",
    Manufacturing:"Manufacturing",
    Professional:"Professional",
    Standard:"Standard",
    product:"product",
    halfProduct:"halfProduct",
    components:"components",
    Parent:"Parent",
    Children:"Children",
    Level:"Level",
    Timing:"Timing",
    PieceCount:"PieceCount",
    Wages:"Wages",
    InternalProcess:"InternalProcess",
    ExternalProcess:"ExternalProcess",
    ProceName:"ProceName",
    ProceIndex:"ProceIndex",
    ChargeMan:"ChargeMan",
    BillMethod:"BillMethod",
    ConsumTime:"ConsumTime",
    Accessories:"Accessories",
    Assembly:"Assembly",
    materials:"materials",
    task:"task",
    process:"process",
    BOM:"BOM",
    Production:"Production",
    RestorePurchaseOneUse:"Restore Purchase （One User,previously purchased only）",
    buy_fail_try_again:"please try again",
    Export:'Export',
    Chart:'Chart',
    Date:"Date",
    BankDetail:"Bank detail",
    Seller:"SellerSeller",
    Buver:"Buver",
    Currency:"Currency",
    CompanyName:"Company Name",
    ProformaInvoice:"Proforma Invoice",
    Discount:"Discount",
    PayStatus:"Pay Status",
    ShippingStatus:"Shipping Status",
    FreightType:"Freight Type",
    Shipping:"Shipping",
    Payment:"Payment",
    Moneyname:"Currency",
	Tax:"Tax",
	Freight:"Freight",
	Insurance:"Insurance",
	Bankfee:"Bankfee",
	Qc:"Quality Certification",
	Exchangerate:"Exchange rate",
  Shippingnumber:"Shipping number",
	ShipDate:"Ship Date",
	Arrivedate:"Arrive date",
	Grossweight:"Gross weight",
	CubicWeight:"Cubic Weight",
	Totalpackages:"Total packages",
  Moneytype:"Currency type",
	Quotedate :"Quote date",
	Validitydate:"Validity date",
	Paymentterm:"Payment term",
	Priceterm:"Price term",
	DeliveryTerm:"Delivery Term",
    BankName:"BankName",
	BankAddress:"Bank Address",
	SwiftCode:"Swift Code",

    Review:"Review",
Signfor:"Signfor",
Finance:"Finance",
    Receiver:"Receiver",
    Profit:"Profit",
    Staff_must_use_in_browser_please_check_the_address_in_help_page:'Staff must use in browser,Please check the address in help page',
    newPassword:'newPassword',
    ForgetPassword:'Forget Password？',
    ContactUs:'Contact Us',
    Actualpay_should_big_then_shouldpay:'Actualpay should big then shouldpay',
    ShopAddress:'My Shop Address',
    All:'All',
    Submit:'Submit',
    OrdernumExists:'OrdernumExists',
    PermissionDenied:'PermissionDenied',
    StockTransfer:'Stock Transfer',
    FromWarehouse:'From Warehouse',
    ToWarehouse:'To Warehouse',
    HistoryPrice:'History Price',
    SerialNumber:'Serial number',
    PleaseUseInWebBrowser:'Please Use In Web Browser',
    PleasePrintInWebBrowser:'Please Print In WebBrowser',
    Please_Use_In_APP:'Please Use In APP',
    Please_Purchase_In_APP:'Please purchase in APP',
    Connect_Postgresql_database_Default_database_is_sqlite_in_local:'Connect Postgresql database ,Default database is sqlite in local',
    Test_connect:'Test connect',
    Connect_Postgresql_database_data_will_store_in_Postgresql:'Connect Postgresql database data will store in Postgresql',
    Use_sqlite_data_will_store_in_local:'Use sqlite data will store in local',
    UsePostgresqlDatabase:'Use Postgresql Database',
    UseSqliteDatabase:' Use Sqlite Database',
    DatabaseName:'Database Name',
    If_has_color_size_initstock_input_0_and_then_add_it_in_purchase:'If product has color size initstock input 0 and then add it in purchase',
    ip:'Database IP',
    port:'Database Port',
    Template:'Template',
    Please_select_a_excel_file:'Please select a excel file' ,
    Please_select_only_one_excel_file:'Please select only one excel file',
    Overdraft:'Overdraft',
    Connect_Internet_Login_again:'Please connect to internet and login again',
    my:'My',
    orderstatus:'Order Status',
    my_shop_qrcode_scan:'My shop qrcode scan and view goods',
productHasValidDate:'product Has ValidDate',
productHasColor:'product Has Color',
GeneralGoods:'General Goods',
Selected:'Selected',
RestorePurchase:'Restore Purchase',
Buy_ElinkInvoice_one_year_use:'Buy ElinkInvoice Enterprise Edition one year use',
Buy_ElinkInvoice_Enterprise_Edition_OneUser:'Buy ElinkInvoice Enterprise Edition OneUser',
Buy_ElinkInvoice_EnterpriseEdition_Unlimited_Users:'Buy ElinkInvoice EnterpriseEdition Unlimited Users',
Purchasing:'wait...',
    Validdate:'Validdate',
    Makedate:'MakeDate',
    Batch:'Batch',
    CheckVersion:'Check version',
    VerifyPurchase:'VerifyPurchase',
Please_set_this_ip_address_on_App:'Please set this ip address on App',
Open_this_link_on_other_Computer_and_Phone_connect_the_same_WiFi:'Open this link on other Computer and Phone connect the same WiFi',
image:'image',

Etit_on_top_field:'Edit order on top field',
    You_need_to_purchase:'You needto purchase',
    Thank_for_your_purchase:'Thank for your purchase',
    New_version_available:'New version available',
    Is_the_latest_version:'Is the latest version',
please:'please',
input:'input',
wrong:'wrong',
Verifycode:'Verify code',
Upload:'Upload',
Download:'Download',
You_need_to_purchase_to_continue_use:'You need to purchase to continue use.If had purchase ,please click restore buy',
CheckBuy:'Check Purchase',
Exists:'Exists',
NetworkUnavailable:'Network Unavailable',
Today:'Today',
Yesterday:'Yesterday',
ThisMonth:'ThisMonth',
LastMonth:'LastMonth',
nickname:'nickname',
storeName:'storeName',
BuyStandAlone:'Buy stand-alone',
PermissionDenied:'Permission denied',
Boss:'Boss',

Buy:'Buy',
login:'Login',
operate:'Operate',
register:'Register',
username:'User name',
password:'Password',
User:'User',
ok:'OK',
back:'Back',
success:'Success',
fail:'Fail',
cancel:'Cancel',
add:'Add',
edit:'Edit',
delete:'Delete',
refresh:'Refresh',
close:'Close',
cancel:'Cancel',
return:'Return',
ElinkInvoice:'Elink Inventory',
Purchase:'Purchase',
BaseData:'BaseData',
Sell:'Sell',
PurchaseReturns:'Purchase returns',
SellReturns:'Sell returns',
Inventory:'Inventory',
Statistics:'Statistics',
Receivable:'Receivable',
Payable:'Payable',
Orders:'Orders',
StockTransferIn:'Stock Transfer In',
StockRecall:'Stock Recall',
Customer:'Customer',
Supplier:'Supplier',
Warehouse:'Warehouse',
Color:'Color',
Size:'Size',
Category:'Category',
Category2:'Category2',
Product:'Product',
Account:'Account',
AccountType:'Account category',
Staff:'Staff',
typeone:'Category',
typetwo:'SubCategory',
ProductName:'Name',
Specification:'Spec',
Barcode:'Barcode',
Buyprice:'Buy price',
Sellprice:'Sell price',
Wholesaleprice:'Wholesale',
Currentstock:'Currents tock',
Unit:'Unit',
Initstock:'Init stock',
Parameter:'Parameter',
transIn:"transIn",
transOut:"transOut",
Remark:'Remark',
Supplier:'Supplier',
Customer:'Customer',
Staff:'Staff',
Receivable:'Receivable',
payable:'payable',
Receipts:'Receipts',
Paid:'Paid',
Preferential:'Preferential',
DateDay:'Date',
OrderNum:'Order Number',
Name:'Name',
UserName:'User Name',
LoginName:'Login Name',
IdNum:'IDNum',
BirthDay:'Birthday',
SEX:'Sex',
Female:'Female',
Male:'Male',
Select:'Select',
Address:'Address',
Phone:'Phone',
Email:'Email',
CardNum:'Card',
Price:'Price',
QTY:'Qty',
SupplierCategory:'Supplier Category',
CustomerCategory:'Customer Category',
Power:'Power',
Role:'Role',
save:'Save',
image:'image',
search:'Search',
Year:'Year',
Month:'Month',
Day:'Day',
Total:'Total',
WorkReport:'Work Report',
Leave:'Leave',
CheckIn:'CheckIn',
Announcement:'Announcement',
Approval:'Approval',
Tracking:'Tracking',
Bill:'Bill',
OrdersDetail:'Orders Detail',
Expense:'Expense',
Income:'Income',
Userfor:'Userfor',
Amount:'Amount',
Title:'Title',
News:'News',
SelectFile:'SelectFile',
Content:'Content',
Cost:'Cost',
ApprovalUser:'Approval User',
ApprovalStatus:'Approval Status',
ApprovalRemark:'Approval Remark',
ApprovalDate:'Approval Date',
SubmitDate:'Submit Date',
Status:'Status',
FromDateTime:'From Date Time',
ToDateTime:'To Date Time',
Subject:'Subject',
Latitude:'Latitude',
Longitude:'Longitude',
Print:'Print',
DataTrans:'DataTrans',
OA:'OA',
Setting:'Setting',
Help:'Help',
ScanOpenInPhone:'Scan Open in Phone',
Building:'Building',
Room:'Room',
HotelCheckIn:'Check in',
CheckOut:'Check out',
Hotel:'Hotel',
Checkintime:'Check in time',
Checkouttime:'Check out time',
Deposit:'Deposit',
Cost:'Cost',
RoomNum:'Room Num',
Rent:'Rent',
costday:'costday',
rent:'rent',
waternum:'Water degree',
electricnum:'Electric degree',
gasnum:'Gas degree',
watercost:'water cost',
electriccost:'electric cost',
gascost:'gas cost',
cleaningcost:'cleaning cost',
networkcost:'network cost',
tvcost:'tv cost',
managecost:'manage cost',
othercost:'other cost',
totalcost:'total cost',
remark:'remark',
addtime:'addtime',
OpenInBrowser:'Open In Browser',
InventoryProfit:'Inventory profit',
InventoryLoss:'Inventory loss',
CompanyInfo:'Company Info',
Refresh:'Refresh',
Add:'Add',
Search:'Search',
Records:'Records',
}



// WEBPACK FOOTER //
// ./src/lang/en.js